import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { investmentStrategyAssetAllocations } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the expertAdvice resource
export const [actions, reducer, resourceSagas] = resourceReducer(
  'investment-strategy-asset-allocations'
);

// Create the sagas for this entity
function* readInvestmentStrategyAssetAllocations() {
  yield takeEvery(actions.indexRequestBegin, function* ({ payload }) {
    const { args } = payload;
    try {
      const result = yield call(investmentStrategyAssetAllocations.get, args);
      const { meta } = result;
      // Define meta by strategyID to keep track of seperate metadata for each strategyId
      const strategyMeta = {};
      strategyMeta[args.strategyId] = meta;

      const normalized = normalize(result);
      yield put(
        actions.indexRequestSuccess({ ...normalized, meta: strategyMeta, args })
      );
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: { error, args } });
    }
  });
}

export const sagas = [readInvestmentStrategyAssetAllocations, ...resourceSagas];
